/* eslint-disable sort-keys */
import type * as core from '../../../../../../../core'

export const query: core.mosaic.Page.Query = {
  selection: {
    '@': 'breadcrumbs',
  },
  subqueries: {
    breadcrumbs: {
      filter: {
        '=': [
          {
            '@$': 'projRecordId',
          },
          {
            '@.': '!id',
          },
        ],
      },
      target: 'ent:!projects:!proj',
      quantity: 1,
      selection: {
        '{}': {
          title: {
            if: [
              [
                {
                  not: {
                    '=': [
                      {
                        '@$': 'projRecordId',
                      },
                      null,
                    ],
                  },
                },
                {
                  '@.': '!name',
                },
              ],
              'Engagements',
            ],
          },
          breadcrumbs: {
            '[]': [
              {
                '{}': {
                  goto: {
                    '{}': {
                      variables: {
                        '{}': {
                          projRecordId: {
                            '@$': 'projRecordId',
                          },
                        },
                      },
                      navigationId: 'projects',
                    },
                  },
                  name: 'Projects',
                },
              },
            ],
          },
        },
      },
    },
  },
}
